import React   from 'react';

import { isMobileDevice } from '../../../utils';
import styles from './Game.css';
import classNames from 'classnames';

type CanvasProps = {
    id: string;
    hidden: boolean;
    shouldComponentUpdate: boolean;
};

export class Canvas extends React.Component<CanvasProps> {
    static displayName = 'Canvas';

    shouldComponentUpdate() {
        return this.props.shouldComponentUpdate;
    }

    render() {
        const {id, hidden} = this.props;

        return (
            <CanvasBox
                aria-hidden = "true"
                id = {id}
                mobileDeviceMode = {isMobileDevice()}
                hidden = {hidden}
            />
        );
    }
}

// Class 'game' is mandatory, since some crosswords disable scroll by this class
const CanvasBox = ({ mobileDeviceMode, hidden, ...props}: any) => (
    <div
        className = {
            classNames(`game ${styles.canvasBox}`, {
                [styles.mobileDeviceMode]: !!mobileDeviceMode,
                [styles.hidden]: hidden
            })
        }
        {...props} />
 );
